<template>
  <span>
    <div>{{ value.name }}</div>
    <b-badge variant="info" class="pt-1" :class="`document-status-button color-${value.status.id}`">{{ value.status.name }}</b-badge>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.document-status-button.color-2, .document-status-button:hover.color-2 {
  background-color: violet;
}
.document-status-button.color-3, .document-status-button:hover.color-3 {
  background-color: orange;
}
.document-status-button.color-4, .document-status-button:hover.color-4 {
  background-color: cadetblue;
}
.document-status-button.color-6, .document-status-button:hover.color-6 {
  background-color: green;
}
.document-status-button.color-7, .document-status-button:hover.color-7 {
  background-color: rebeccapurple;
}
.document-status-button.color-9, .document-status-button:hover.color-9 {
  background-color: red;
}
</style>
